// extracted by mini-css-extract-plugin
export var noSpinners = "_nk-6";
export var percentageInput = "_nk-7";
export var variantColor1 = "_nk-0";
export var variantColor2 = "_nk-1";
export var variantColor3 = "_nk-2";
export var variantColor4 = "_nk-3";
export var variantColor5 = "_nk-4";
export var variantColor6 = "_nk-5";